import { ref } from '@vue/composition-api'
import {
  mdiCash,
  mdiCreditCard,
  mdiCreditCardOutline,
  mdiBankTransfer,
  mdiCheckbook,
  mdiCellphone,
  mdiBitcoin,
  mdiTicket,
  mdiMonitor,
  mdiStore,
} from '@mdi/js'

export default function usePaymentsTypesList() {
  const paymentsTypesList = ref([
    {
      id: 1,
      text: 'Efectivo',
      color: '#009688',
      icon: mdiCash,
    },
    {
      id: 2,
      text: 'Tarjeta de crédito',
      color: '#2196F3',
      icon: mdiCreditCard,
    },
    {
      id: 3,
      text: 'Tarjeta de débito',
      color: '#FFEB3B',
      icon: mdiCreditCardOutline,
    },
    {
      id: 4,
      text: 'Transferencia bancaria',
      color: '#4CAF50',
      icon: mdiBankTransfer,
    },
    {
      id: 5,
      text: 'Cheque',
      color: '#FF9800',
      icon: mdiCheckbook,
    },
    {
      id: 6,
      text: 'Pago móvil',
      color: '#673AB7',
      icon: mdiCellphone,
    },
    {
      id: 7,
      text: 'Criptomoneda',
      color: '#F44336',
      icon: mdiBitcoin,
    },
    {
      id: 8,
      text: 'Vales o cupones',
      color: '#9C27B0',
      icon: mdiTicket,
    },
    {
      id: 9,
      text: 'Pago electrónico',
      color: '#3F51B5',
      icon: mdiMonitor,
    },
    {
      id: 10,
      text: 'Pago en tienda',
      color: '#FF5722',
      icon: mdiStore,
    },
  ])

  const GetById = id => paymentsTypesList.value.find(item => item.id === id)

  return {
    paymentsTypesList,
    GetById,
  }
}
